"use client";
import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { CommandGroup } from "../_shadcn-native-components/command.js";
import { cn } from "../utils.js";
import { useDropdownContext } from "./context.js";
const DropdownBaseList = ({ className, selected, multiselect, onSelect, ...props })=>{
    const { setValues } = useDropdownContext();
    useEffect(()=>{
        if (!selected) return;
        'string' == typeof selected || 'number' == typeof selected ? setValues([
            selected
        ]) : setValues(selected);
    }, [
        selected
    ]);
    return /*#__PURE__*/ jsx(CommandGroup, {
        className: cn('tw-max-h-24 tw-overflow-y-auto', className),
        ...props
    });
};
export { DropdownBaseList };
